export const columns = [
  {
    accessorKey: "sNo",
    header: "Serial #",
    flex: 1,
  },
  {
    accessorKey: "typeOfCargo",
    header: "Cargo",
    type: "string",
    flex: 1,
  },

  {
    accessorKey: "totalWeight",
    header: "Total Weight",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.totalWeight || 0}`,
  },
];
